import { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  openUpsellAndTrackActivity,
  closeNowPlayingDialog,
} from 'src/common/actions/dialog';
import { labels } from 'src/common/constants/analytics/categoryActionLabel/subscribe';
import { selectIsNowPlayingDialogOpen } from 'src/common/selectors/dialog';
import { selectIsMobile } from 'src/common/selectors/app';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import getSubscribeEventLabel from '../../../utils/subscription/getSubscribeEventLabel';
import debounce from '../../../utils/debounce';
import { isTopic } from '../../../utils/guideItemTypes';
import css from './guide-item.module.scss';

export function LockedTile({
  guideItem,
  children,
  actions,
  style,
  className,
  dataTestId = 'lockedItem',
  isClickHandlerEnabled = true,

  // mapStateToProps
  isMobile,
  isNowPlayingDialogOpen,
}) {
  const { location } = useContext(LocationAndLocalizationContext);

  const handleClick = debounce(() => {
    let parentGuideId;
    let topicGuideId;

    const isTopicGuideId = isTopic(guideItem.guideId);

    if (isTopicGuideId) {
      parentGuideId = get(
        guideItem,
        'properties.parentProgram.destinationInfo.id',
      );
      // we want the topicGuideId to be set only when guide id is a topic
      topicGuideId = guideItem.guideId;
    }
    const eventLabel = getSubscribeEventLabel(
      labels.profileUpsellDialog,
      location,
    );
    const products = [
      get(guideItem, 'actions.subscribe.product'),
      get(guideItem, 'actions.subscribe.productSecondary'),
    ].filter(Boolean);

    if (isMobile && isNowPlayingDialogOpen) {
      actions.closeNowPlayingDialog();
    }

    actions.openUpsellAndTrackActivity(
      eventLabel,
      parentGuideId || guideItem.guideId,
      topicGuideId,
      products,
      guideItem.image,
      guideItem.title,
    );
  });

  return (
    <div
      data-testid={dataTestId}
      className={classNames([className, css.guideItemLink])}
      style={style}
      onClick={isClickHandlerEnabled ? handleClick : null}
    >
      {children}
    </div>
  );
}

LockedTile.propTypes = {
  guideItem: PropTypes.object,
  children: PropTypes.node.isRequired,
  actions: PropTypes.object.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  isClickHandlerEnabled: PropTypes.bool,
  // mapStateToProps
  isMobile: PropTypes.bool.isRequired,
  isNowPlayingDialogOpen: PropTypes.bool.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        openUpsellAndTrackActivity,
        closeNowPlayingDialog,
      },
      dispatch,
    ),
  };
}

const mapStateToProps = (state) => ({
  isMobile: selectIsMobile(state),
  isNowPlayingDialogOpen: selectIsNowPlayingDialogOpen(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(LockedTile);
